import React,{Component} from 'react';
import {browserHistory,Link} from 'react-router';
import { Modal, Panel, Button,Image} from 'react-bootstrap';


import Footer from './Categories/Common/footer';
import Close_ad from './Categories/Common/close_ad';
import { ShareButtons, generateShareIcon } from 'react-share';
import { OffCanvas, OffCanvasMenu} from 'react-offcanvas';
import ADStores from './Categories/Stores/ADStores.js';
// import HomeAds from './Categories/Common/HomeAds.js';
import BannerAds from './Categories/Common/BannerAds.js';
// import Promotions from './Categories/Promotions/Promotions.js';
import PromotionsNew from './Categories/Promotions/PromotionsNew.js';
import BrandStores from './Categories/Stores/BrandStores.js';
import Recommended from './Categories/Promotions/Recommended.js';
import $ from 'jquery';

const baseUrl='https://aquadeals.in/admin/web3/user/';
const baseAssets = 'https://aquadeals.in/admin/assets/';

const {FacebookShareButton,GooglePlusShareButton,TwitterShareButton} = ShareButtons;
const FacebookIcon = generateShareIcon('facebook');
const TwitterIcon = generateShareIcon('twitter');
const GooglePlusIcon = generateShareIcon('google');

export default class App extends Component{
  constructor(props){
    super(props);
    this.state={
        showModal: false,
        shareModal:false,
        open: false,
        isMenuOpened: false,
        pro_pic: 'default_img.png',
        name: '',
        mobile: '',
        email: '',
        deal_types: [],
        cart_count:'',
        noty_count:'',
        aquacash:'',
        bookings:'',
        smart_cart_flag:'',
        wishlist_count:'',
        reg_as_partner:false,
        is_loaded_dtypes:false,
        // page_loading:true,
    }
    this.modalOpen=this.modalOpen.bind(this);
    this.close=this.close.bind(this);
    this.closeModal=this.closeModal.bind(this);
    this.modalOpen1=this.modalOpen1.bind(this);
    this.close1=this.close1.bind(this);
    this.closeModal1=this.closeModal1.bind(this);
    this.getDeviceId=this.getDeviceId.bind(this);
    this.getDashboardIcons=this.getDashboardIcons.bind(this);

    this.getCartCount=this.getCartCount.bind(this);
    this.dashBoard=this.dashBoard.bind(this);
    this.reg_as_partner_show=this.reg_as_partner_show.bind(this);

  }
  reg_as_partner_show()
  {
    if(localStorage.user_id)
    {
      var uid=localStorage.user_id;
    }
    else
    {
      uid=0;
    }
    var data1={from:'mobile_web',uid:uid,token:localStorage.token,}
    var data2=JSON.stringify(data1);
    $.ajax({
      method:'POST',
      dataType:'json',
      url:baseUrl+'reg_as_partner_show',
      data:{req:data2},
      success:function(data)
      {
          if(data.status==='success' && data.flag==='1')
          {
            this.setState({
                reg_as_partner:true,
            });
          }
      }.bind(this),
      error:function(err)
      {
      }
    })
  }
  dashBoard()
  {
      var data1={from: 'mobile_web',id:localStorage.getItem('user_id'),token:localStorage.getItem('token')};
      var data2=JSON.stringify(data1);
      $.ajax({
            method: 'POST',
            url: baseUrl+'dashboard',
            dataType:'json',
            data: {req:data2},
            success: function(data)
            {
              this.setState({
                  aquacash:data.aquacash,
                  bookings:data.bookings,
                  noty_count:data.notifications,
                  wishlist_count:data.wish_list,
              });
            }.bind(this),
            error: function(err)
            {
            
            }
      });
  }
  getCartCount()
  {
      var data1={from: 'mobile_web',id:localStorage.getItem('user_id'),token:localStorage.getItem('token')};
      var data2=JSON.stringify(data1);
      $.ajax({
            method: 'POST',
            url: baseUrl+'cart_count',
            dataType:'json',
            data: {req:data2},
            success: function(data)
            {
              if(data.status==='success')
              {
                this.setState({
                  cart_count:data.cart_count,
                }); 
              }
             else if(data.status==='error' && data.message==='Token mismatch')
             {
                localStorage.clear();
                window.location.reload();
             }
            }.bind(this),
            error: function(err)
            {
            
            }
      });
  }
  getDashboardIcons()
  {
     var data1={from:'mobile_web'};
     var data2=JSON.stringify(data1);
     $.ajax({
          method:'post',
          url:baseUrl+'dashboard_icons',
          dataType:'json',
          data: {req:data2},
          success:function(data)
          {
              this.setState({
                  deal_types: data.deal_types,
                  aboutusUrl:data.aboutusUrl,
                  is_loaded_dtypes: true
              });
          }.bind(this),
          error:function(err)
          {
            // this.setState({
            //  page_loading:false,
            // });
          }
     });
  }
  getDeviceId()
  {
      if(localStorage.user_id)
      {
          var user_id=localStorage.user_id;
      }
      else
      {
        user_id=0;
      }
      var data1={from: 'mobile_web',id: user_id, device_id: localStorage.getItem('push_device_id')}
      var data2=JSON.stringify(data1);
      $.ajax({
          method: 'POST',
          url: baseUrl+'getDeviceId',
          dataType: 'json',
          data:{req: data2},
          success: function(data){
            
          },
          error: function(err){
          }
      });
  }
  handleClick(){this.setState({isMenuOpened: !this.state.isMenuOpened});} 
  modalOpen(){this.setState({showModal: true});}
  closeModal(){this.setState({showModal: false});}
  close(){this.setState({showModal: false});}
  modalOpen1(){this.setState({shareModal: true});}
  closeModal1(){this.setState({shareModal: false});}
  close1(){this.setState({shareModal: false});}
  
  logout()
  {
      localStorage.clear();
      window.location.reload();
  }
  componentDidMount()
  {
      if(screen.width >= 800)
      {
         window.location.href="/web/home";
      }
      $.getJSON('https://api.ipify.org?format=json', function(data){
          localStorage.setItem('ip',data.ip);
      });
      if(localStorage.user_id && localStorage.token)
      {
        this.getCartCount();
        this.dashBoard();
      }
      this.reg_as_partner_show();

      localStorage.removeItem('brand_details');
      localStorage.removeItem('m_r_s_dt');
      localStorage.removeItem('m_r_e_coupon_dt');
      localStorage.removeItem('m_r_e_s_dt');
      localStorage.removeItem('mob_mycart');
      localStorage.removeItem('m_r_enq_seller_page');
      localStorage.removeItem('m_r_p_dt');
      localStorage.removeItem('m_r_e_p_dt');
      localStorage.removeItem('ofr_page');
      localStorage.removeItem('profile');
      localStorage.removeItem('pro_ofr_dtls');
      localStorage.removeItem('myaquacash');
      localStorage.removeItem('share_earn');
      localStorage.removeItem('checkout');
      localStorage.removeItem('order_details');
      localStorage.removeItem('my_orders');
      localStorage.removeItem('m_r_p_deals');
      localStorage.removeItem('m_r_p_deals');
      localStorage.removeItem('seed');
      localStorage.removeItem('nauplii');
      localStorage.removeItem('subdeals');
      localStorage.removeItem('myorders');
      localStorage.removeItem('offers');
      localStorage.removeItem('shipping');
      localStorage.removeItem('notifications');
      localStorage.removeItem('mob_quickcart');
      localStorage.removeItem('view_rating');
      localStorage.removeItem('give_rating');
      localStorage.removeItem('cat_page');
      localStorage.removeItem('w_r_s_dt');
      localStorage.removeItem('wishlist');
      localStorage.removeItem('smartcart');
      localStorage.removeItem('about_brand');
      
      localStorage.removeItem('currPath');
      localStorage.removeItem('w_r_p_dt');
      localStorage.removeItem('pprice');
      localStorage.removeItem('sprice');
      localStorage.removeItem('seed_id');
      localStorage.removeItem('h_type');
      localStorage.removeItem('w_r_e_p_dt');
      localStorage.removeItem('w_r_e_p_dt');
      localStorage.removeItem('w_r_p_deals');
      localStorage.removeItem('w_r_seed_deals');
      localStorage.removeItem('w_modal_details');  
      localStorage.removeItem('m_r_enq_seller_page');
      localStorage.removeItem('cat_id');
      localStorage.removeItem('cat');
      localStorage.removeItem('cat_sort');
      localStorage.removeItem('url');
      localStorage.removeItem('mob_mycart');
      localStorage.removeItem('brand');
      localStorage.removeItem('sort');
      localStorage.removeItem('Tid');
      localStorage.removeItem('type');
      localStorage.removeItem('d_type');
      localStorage.removeItem('apply_coupon_code');
      localStorage.removeItem('apply_coupon');
      localStorage.removeItem('address_change_flag');
      localStorage.removeItem('book_date');
      localStorage.removeItem('seller');
      localStorage.removeItem('vid');

      
      this.getDeviceId();
      this.getDashboardIcons();
      //this.getDashboardBlocks();
      if(localStorage.token && localStorage.user_id) 
      {
          var data1={from:'mobile_web',uid:localStorage.getItem('user_id'),token: localStorage.getItem('token')};
          var data2=JSON.stringify(data1);
          $.ajax({
              method: 'post',
              url: baseUrl+'myprofile',
              dataType:'json',
              data: {req: data2},
              success: function(data)
              {
                if(data.msg==='success')
                {
                  this.setState({
                      pro_pic: data.details[0].pro_pic,
                      name: data.details[0].name,
                      mobile: data.details[0].mobile,
                      email:data.details[0].email,
                      smart_cart_flag:data.smart_cart_flag,
                  });
                }
                if(data.status ==='error' && data.message ==='Token mismatch')
                {
                   localStorage.clear();
                     window.location.reload();
                }
              }.bind(this),
              error: function(err)
              {
              }
        });
      }
  }
  search()
  {
      browserHistory.push('/search');
  }
  
  render(){
    document.title ="Online AquaCulture MarketPlace - Find best deals on Seed, Feed, Health Care, Machinery & Farm Equipments, Products, Ropes & Nets Paddle Wheels and More | AquaDeals";
    document.getElementsByTagName("META")[2].content="It is a place for deals related to Aqua culture";
    var shareUrl="http://tinyurl.com/aquadotdeals";
    var title="Download AquaDeals Android app at";
    var description="http://tinyurl.com/aquadotdeals";
    var menu_log = ''
    if(localStorage.token)
    {
        menu_log = <li onClick={this.logout.bind(this)}><a><i><img src={baseAssets+'icons/signout.png'} alt=""/></i>Logout</a></li>;
    }
    else
    {
        menu_log = <li><Link to="/login"><i><img src={baseAssets+'icons/signin.png'} alt=""/></i>Login/Sign Up</Link></li>;
    }   
    var dboard_icons=this.state.deal_types.map(function(item,index){
        return(
              <div className="" style={{paddingTop:'7px',paddingBottom:'7px',overflow:'hidden'}}>
                {item.dtypes.map(function(x){
                  if(x.url_name==='seed'){
                    var route=x.url_name;
                  }
                  else if(x.deal_type ==='1'){
                      route=x.url_name;
                  }
                  else if(x.url_name==='Categories'){
                      route =x.url_name;
                  }
                  else if(x.deal_type ==='8'){
                      route = '/nauplii';
                  }
                  else {
                      route='/pdeals/'+x.url_name+'/all/'+x.id;  
                  }
                  return (
                      <div className="col-xs-3 col-md-3">        
                          <Link to={route} className="blk_item">
                              <img src={baseAssets+'icons/'+x.icon} alt=""/>
                              <h6>{x.type}</h6>
                          </Link>
                      </div>
                )
              })}</div>
        )
    });
   
    return (
        <div className="mob_deals mob_homepage">
          {/*{this.state.page_loading ? <i className="homepage_loading"><img src={baseAssets+'images/loading_more.gif'} alt="Loading" /></i> 
          : <div>*/}
          <Close_ad />
          <div className="page_hdr page_hdr_hme">
                  <div className="container-fluid">
                      <h4><a onClick={this.handleClick.bind(this)} className="hm_menu_btn"  style={{float:'left'}}><i className="glyphicon glyphicon-menu-hamburger"></i></a></h4> 
                      <div className="hdr_srch">
                        <form className="navbar-form navbar-left">
                            <div className="form-group">
                              <input type="text" className="form-control" placeholder="Search for brands and products" onClick={this.search} />
                              <img onClick={()=>{browserHistory.push('/search')}} src={baseAssets+'images/web_imgs/search.png'} width="15px" className="mob_cart_cnt_img" alt=""/> 
                            </div>
                            <a className="mob_home_cart_btn" href="/mycart">
                                <img alt="" src={baseAssets+'icons/web_icons/cart_icon.png'} />
                                {this.state.cart_count > 0 ? <span className={"mob_cart_count1"}>{this.state.cart_count > 9 ? '' : <span>&nbsp;</span>}{this.state.cart_count}</span> : ''}
                            </a>
                            <a className="mob_home_noty_btn" href="/notifications">
                              <img src={baseAssets+'mob-assets/home_notification_hdr.png'} alt=""/>
                              {this.state.noty_count > 0 ? <span className={"mob_noty_count1"}>{this.state.noty_count > 9 ? '': <span>&nbsp;</span>}{this.state.noty_count}</span> : ''}
                            </a>
                            
                            {/* <button type="button" onClick={this.search} className="btn btn-default srch_btn"><img src={baseAssets+'images/web_imgs/search.png'} alt="" /></button> */}
                        </form>
                      </div>
                  </div>
              </div>
              <OffCanvas width={250} transitionDuration={300} isMenuOpened={this.state.isMenuOpened} position={"left"}>
                    <OffCanvasMenu className="side_menu" >
                        <span className="pull-right glyphicon glyphicon-remove-circle" onClick={()=>{this.setState({isMenuOpened:false})}}></span>
                        <div className="side_bar_prfil">
                            <div className="side_bar_prfil_pic">
                                {/*  <img src={baseAssets+'images/pro_pics/'+this.state.pro_pic} title="" alt=".." /> */}
                              <Link to={"/profile"}><Image src={baseAssets+'images/pro_pics/'+this.state.pro_pic} alt="" circle width="100%" height="100%" style={{marginLeft:'0px',marginTop:'0px'}} /></Link>
                            </div>
                            <h5>{this.state.name ? this.state.name : 'Welcome'}</h5>
                            {this.state.email ? <h6>{this.state.email}</h6> : ''}
                         </div>
                         <div className="side_bar_menu">
                              <ul>
                                  <li><Link to={'/myaquacash'} title="My AquaCash"><i><img src={baseAssets+'mob-assets/nav_aquacash.png'} alt=""/></i>My Aquacash{this.state.aquacash ? <span className="nav_menu_right">&#8377;{this.state.aquacash}</span>: ''}</Link></li>
                                  <li><Link to={'/myorders'} title="My Orders"><i><img src={baseAssets+'mob-assets/nav_my_bookings.png'} alt=""/></i>My Orders{this.state.bookings ? <span className="nav_menu_right">{this.state.bookings}</span> : ''}</Link></li>
                                  {/*<li><a onClick={this.modalOpen}><i><img src={baseAssets+'mob-assets/nav_my_bookings.png'} alt=""/></i>My Orders{this.state.bookings ? <span className="nav_menu_right">{this.state.bookings}</span> : ''}</a></li>*/}
                                  {/*<li><a onClick={this.modalOpen}><i><img src={baseAssets+'mob-assets/cart_icon.png'} alt=""/></i>My Cart</a></li> */}
                                  <li><Link to={'/mycart'} title="My Cart"><i><img src={baseAssets+'mob-assets/cart_icon.png'} alt=""/></i>My Cart {this.state.cart_count >0 ? <span className="nav_menu_right">{this.state.cart_count}</span>: ''}</Link></li>
                                  {this.state.smart_cart_flag===1 ? <li><Link to={'/smartcart'} title="Smart Cart"><i><img src={baseAssets+'mob-assets/cart_icon.png'} alt=""/></i>Smart Cart</Link></li> : ''}
                                  <li><Link to={'/wishlist'} title="Wish List"><i><img src={baseAssets+'mob-assets/wishlist_nav.png'} alt=""/></i>Wishlist {this.state.wishlist_count > 0 ? <span className="nav_menu_right">{this.state.wishlist_count}</span> : ''}</Link></li>
                                  <li><Link to={"/profile"} title="My Profile"><i><img src={baseAssets+'mob-assets/home_my_profile.png'} alt=""/></i>My Profile</Link></li>
                                  {/*<li><a onClick={this.modalOpen}><i><img src={baseAssets+'mob-assets/home_my_profile.png'} alt=""/></i>My Profile</a></li>*/}
                                  <li><Link to={'/notifications'} title="Notifications"><i><img src={baseAssets+'mob-assets/home_notification_hdr.png'} alt=""/></i>Notifications {this.state.noty_count > 0 ? <span className="nav_menu_right">{this.state.noty_count}</span> : ''}</Link></li>
                                  {/*<li><a onClick={this.modalOpen}><i><img src={baseAssets+'mob-assets/home_notification_hdr.png'} alt=""/></i>Notifications</a></li>*/}
                                  <li><Link to={'/offerszone'} title="Offers Zone"><i><img src={baseAssets+'mob-assets/nav_offers.png'} alt=""/></i>Offers Zone</Link></li>
                                  <li><Link to={'/share_earn'} title="Share & Earn"><i><img src={baseAssets+'mob-assets/nav_refer_earn.png'} alt=""/></i>Share & Earn</Link></li>
                                  <li><Link to="/customer_care" title="Customer Care"><i><img src={baseAssets+'mob-assets/nav_customer_care.png'} alt=""/></i>Customer Support</Link></li>
                                  <li><a href="http://blog.aqua.deals" title="AquaDeals Blog" target="_blank"><i><img src={baseAssets+'mob-assets/blogger-logo.png'} alt=""/></i>Blog</a></li>
                                  {this.state.aboutusUrl !=="" ? 
                                  <li onClick={()=>{this.setState({isMenuOpened:false})}}><a href={this.state.aboutusUrl} title="About Us" target="_blank"><i><img src={require('./../assets/images/nav_aboutus.png')} alt="..."></img></i>About Us</a></li>                                  
                                  : ''}
                                  {/*<li><a onClick={this.modalOpen1} ><i><img src={baseAssets+'mob-assets/nav_share_icon.png'} alt=""/></i>Share</a></li> */}
                                  {/*<li><a onClick={this.modalOpen}><i><img src={baseAssets+'mob-assets/rateus.png'} alt=""/></i>Rate Us</a></li>*/}
                                  {menu_log}
                                  
                                  <p style={{color:'#666',paddingLeft:'23px',paddingTop:'10px',borderTop:'1px solid #ccc'}}>Our Other Apps</p>
                                  <li><a href={'https://play.google.com/store/apps/details?id=com.aqua.build'} target="_blank" title="AquaBrahma"><i><img src={baseAssets+'icons/web_icons/ab-lgn.png'} alt=""/></i>AquaBrahma</a></li>
                              </ul>
                        </div>
                    </OffCanvasMenu>
              </OffCanvas>
              {/*<HomeAds />*/}
              <BannerAds />
              <div className="test_close" onClick={()=>{this.setState({isMenuOpened:false})}}>
                {this.state.is_loaded_dtypes ? 
                <div className="hm_main_icons">
                    {dboard_icons}
                </div>
                : ''}
                  <section>
                      <ADStores />
                  </section>
                  <section>
                      <BrandStores />
                  </section>

                    <Recommended />
                  <section style={{backgroundColor:'#fff',marginTop:'10px'}}>
                    {/*<Promotions />*/}
                    <PromotionsNew />
                  </section>
                  {this.state.reg_as_partner ? 
                  <section className="want_to_sell">
                      <Link to={"/enquire_now/partner/support/sid/did"}>
                        <div className="col-md-2 col-sm-2 col-xs-2" style={{padding:'0px',textAlign:'center'}}>
                            <img src={baseAssets+'icons/partner.png'} alt="" />
                        </div>
                        <div className="col-md-8 col-sm-8 col-xs-8" style={{color:'#666',padding:'0px',position:'relative',top:'4px'}}>
                            <h5>REGISTER AS PARTNER</h5>
                            <h6>start selling with AquaDeals</h6>
                        </div>
                        <div className="col-md-2 col-sm-2 col-xs-2 pull-right" >
                            <span className="promo_right_arrow_img"><img src={baseAssets+'icons/right_arrow_gray.png'} alt="" /></span>
                        </div>
                      </Link>
                  </section> : ''}
                  <Modal className="showModal" show={this.state.showModal} style={{zIndex: '1111'}} onHide={this.close} >
                      <Modal.Header closeButton>
                          <Modal.Title style={{fontSize: '16px',color:'#333'}}>AquaDeals</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                          <h4 style={{fontSize:'14px', color:'#666'}}>You need to install Android mobile app to proceed further</h4>
                      </Modal.Body>
                      <Modal.Footer className="modal_footer">
                          <Button style={{background: '#fff none repeat scroll 0 0',color:'#ff742a'}} onClick={this.closeModal}>Close</Button>
                          <a href="https://play.google.com/store/apps/details?id=com.aquadeals.user&hl=en" target="_blank" title=""><Button style={{background: '#ff742a none repeat scroll 0 0',color: '#fff'}}>OK</Button></a>
                      </Modal.Footer>
                  </Modal>
                  <Modal className="showModal" show={this.state.shareModal} style={{zIndex: '1111'}} onHide={this.close1} >
                      <Modal.Header closeButton>
                          <Modal.Title style={{fontSize: '16px',color:'#333'}}>Share AquaDeals App</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                          <h4 style={{fontSize:'14px', color:'#666'}}></h4>
                          <div>
                              <Panel className="" style={{marginLeft:'30%'}} collapsible expanded={!this.state.open}>
                                  <FacebookShareButton url={shareUrl} title={title} description={description} className="test_share2">
                                    <FacebookIcon size={32} round />
                                  </FacebookShareButton>
                                  <TwitterShareButton url={shareUrl} title={title} description={description} className="test_share2">
                                    <TwitterIcon size={32} round />
                                  </TwitterShareButton>
                                  <GooglePlusShareButton url={shareUrl} title={title} description={description} className="test_share2">
                                      <GooglePlusIcon size={32} round />
                                  </GooglePlusShareButton>
                              </Panel>
                          </div>
                      </Modal.Body>
                      <Modal.Footer className="modal_footer">
                          <Button style={{background: '#fff none repeat scroll 0 0',color:'#ff742a'}} onClick={this.closeModal1}>Close</Button>
                      </Modal.Footer>
                  </Modal>

            </div>
            {/*<Footer />*/}
            {/*</div> } */}
      </div>   
    );
  }
}


/** WEBPACK FOOTER **
 ** ./src/components/App.js
 **/